module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row page-section"
  }, [_c('div', {
    staticClass: "large-12 columns"
  }, [(_vm.hasData && !_vm.showError) ? _c('div', {
    staticClass: "block block-main block-live-main"
  }, [(_vm.showImageBox) ? _c('top-image-box') : _vm._e(), _vm._v(" "), _c('top-text-box')], 1) : _c('div', {
    staticClass: "block block-main"
  }, [_c('div', {
    staticClass: "block-main-media"
  }, [_c('img', {
    attrs: {
      "src": _vm.errorImage,
      "alt": "Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block-main-content block-main-content-alert center "
  }, [_c('div', [_c('h2', {
    staticClass: "block-main-title"
  }, [_vm._v(_vm._s(_vm.errorTitle))]), _vm._v(" "), _c('p', {
    staticClass: "block-main-excerpt",
    domProps: {
      "innerHTML": _vm._s(_vm.errorText)
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2fbcf06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top/Top.vue
// module id = 105
// module chunks = 1